export const FETCH_PROJECTS = "FETCH_PROJECTS"
export const ADD_PROJECT = "ADD_PROJECT"
export const UPDATE_PROJECT = "UPDATE_PROJECT"
export const SELECT_PROJECT = "SELECT_PROJECT"
export const SET_FETCHED_PROJECT = "SET_FETCHED_PROJECT"
export const DESELECT_PROJECT = "DESELECT_PROJECT"
export const REMOVE_PROJECT = "REMOVE_PROJECT"
export const ADD_TASK = "ADD_TASK"
export const SELECT_TASK = "SELECT_TASK"
export const DESELECT_TASK = "DESELECT_TASK"
export const UPDATE_TASK = "UPDATE_TASK"
export const REMOVE_TASK = "REMOVE_TASK"